import Cookie from './cookie';

var cookie_name = 'fts_popup';
var cookie      = new Cookie();

// get popup div
var notification_div = document.querySelector( '.js-toggle-notification' );

// if no popup cookie set
if ( null === cookie.getCookie( cookie_name ) && notification_div != null ) {
	// after 5 seconds, set animate class on popup
	setTimeout( function() {
		notification_div.classList.toggle( 'notification--animate' );
	}, 5000 );

}

// if close button is present
if ( notification_div != null ) {

	// detect click on button
	notification_div.onclick = function() {
		// close popup
		notification_div.classList.toggle( 'notification--animate-out' );
		// set cookie for 24 hours
		cookie.setCookie( cookie_name, '1', 60*60*24 );
	}
}